// extracted by mini-css-extract-plugin
export default {"user_question":"UserQuestion_user_question__Bzkoe"};